/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox } from 'antd';
import exchanges from "../../common/exchanges";
import exchangesWithParams from "../../common/exchanges-with-params";
import testProfile from "../../common/helpers/test-profile";
import fetchProfileURL from "../../common/helpers/fetch-profile-url";
import { CloseOutlined } from '@ant-design/icons';
import dex from "../../common/dex";
const { TextArea } = Input;



const CreateProfileModal = ({ displayCreateProfile, setDisplayCreateProfile, onProfileCreate }) => {

    const [step, setStep] = useState(0);
    const [profile, setProfile] = useState({
        name: null,
        exchange: null,
        api_key: null,
        api_secret: null,
        custom_api_url: null,
        custom_websocket_url: null,
        is_sandbox: false,
    })
    const [profileBalance, setProfileBalance] = useState()
    const [profileLoading, setProfileLoading] = useState(false)
    const [error, setError] = useState();
    const goBack = () => {
        if (step !== 0) {
            setStep(step - 1);
        } else {
            setDisplayCreateProfile(false);
        }
    }
    const onClickNext = () => {
        if (step !== 2) {
            if (!profile.name) {
                message.error({ content: 'Enter profile name' })
            } else {
                setStep(step + 1);
            }
        } else {
            if (!profileBalance?.error) {
                onProfileCreate(profile);
                setDisplayCreateProfile(false);
                setStep(0);
            }
        }
    }

    const handleConnect = async () => {
        if (profile.exchange === 'hollaex') {
            if (profile.custom_websocket_url.length > 0 && !profile.custom_websocket_url.startsWith('ws')) {
                message.error('Websocket Url should start with "ws:", "wss:", or "ws+unix:"')
                return;
            }
        }

        setProfileLoading(true)
        testProfile(profile).then(res => {
            delete res.info;
            let newArr = [];
            let hasTotal = false;

            Object.keys(res).forEach(key => {
                if (res?.[key]?.hasOwnProperty('total')) {
                    hasTotal = true;
                    newArr.push({ key, total: res?.[key]?.total })
                }
            })
            if (!hasTotal) {
                setProfileBalance(res);
            } else {
                setProfileBalance(newArr);
            }

            setProfileLoading(false);
        }).catch(err => {
            console.log({ err })
            setError(err)
            setProfileLoading(false);
        })
        setStep(2);
    }

    const getProfileUrl = (exchange, sandboxToggled = false) => {
        fetchProfileURL(exchange).then(urls => {
            let isSameFormat = false;
            let hasTest = false;

            if (urls?.api?.rest && urls?.api?.ws) isSameFormat = true;
            if (urls?.test?.rest && urls?.test?.ws) hasTest = true;

            if (isSameFormat) {
                setProfile({
                    ...profile,
                    ...(!sandboxToggled && { api_key: null }),
                    ...(!sandboxToggled && { api_secret: null }),
                    ...(!sandboxToggled && { password: null }),
                    ...(!sandboxToggled && { token: null }),
                    exchange: exchange,
                    custom_api_url: (profile.is_sandbox && hasTest) ? urls?.test?.rest : urls?.api?.rest,
                    custom_websocket_url: (profile.is_sandbox && hasTest) ? urls?.test?.ws : urls?.api?.ws
                })
            } else {
                setProfile({
                    ...profile,
                    ...(!sandboxToggled && { api_key: null }),
                    ...(!sandboxToggled && { api_secret: null }),
                    ...(!sandboxToggled && { password: null }),
                    ...(!sandboxToggled && { token: null }),
                    exchange: exchange,
                    custom_api_url: null,
                    custom_websocket_url: null
                })
            }
        })
    }
    useEffect(() => {
        if (profile.exchange) {
            getProfileUrl(profile.exchange, true)
        }
    }, [profile.is_sandbox])
    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayCreateProfile} footer={null} onCancel={() => { setDisplayCreateProfile(false); }}>

            {step === 0 ?
                <>
                    <div style={{ fontWeight: "600", color: "white" }}>New Exchange API profile</div>
                    <div style={{ color: "grey", marginTop: 10 }}>Create a new exchange API profile below.This can be attached to your bots for the propose of order strategizing and more.</div>
                    <div style={{ color: "white", margin: "30px 0" }}>
                        <label>Name</label>
                        <Input value={profile.name} onChange={(e) => { setProfile({ ...profile, name: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Name the profile" />
                    </div>

                </> :
                step === 1 ?

                    <>
                        <div style={{ fontWeight: "600", color: "white" }}>New Exchange API profile</div>
                        <div style={{ color: "grey", marginTop: 10 }}>Connect an exchange account by inputting its API details below. You can get these details visiting your API key page on your exchange account.</div>
                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>Exchange platform</label>
                            <Select
                                showSearch
                                value={profile.exchange} onChange={(value) => {
                                    getProfileUrl(value);
                                }}
                                style={{ width: "100%", marginTop: 10 }}
                                placeholder="Select profile"

                            >
                                {exchanges.map(x => <Option value={x.value}>{x.label}</Option>)}
                            </Select>
                        </div>

                        {profile.exchange && <div style={{ color: "white", marginBottom: 30, padding: 10 }}>
                            <div style={{ border: "1px solid grey", width: "100%", padding: "0 20px" }}>
                                <h1 style={{ width: 200, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>{exchanges.find(x => x.value === profile.exchange).label} API key details</h1>

                                {Object.keys(exchangesWithParams).includes(profile.exchange) ?
                                    <>
                                        {exchangesWithParams[profile.exchange].type === 'only' ? <></> :
                                            <>
                                                <div style={{ color: "white", margin: "30px 0" }}>
                                                    <label>API key</label>
                                                    <Input value={profile.api_key} onChange={(e) => { setProfile({ ...profile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                                </div>
                                                <div style={{ color: "white" }}>
                                                    <label>API secret</label>
                                                    <Input value={profile.api_secret} onChange={(e) => { setProfile({ ...profile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                                </div>
                                            </>
                                        }

                                    </> :
                                    <>
                                        <div style={{ color: "white", margin: "30px 0" }}>
                                            <label>API key</label>
                                            <Input value={profile.api_key} onChange={(e) => { setProfile({ ...profile, api_key: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API key" />
                                        </div>
                                        <div style={{ color: "white" }}>
                                            <label>API secret</label>
                                            <Input value={profile.api_secret} onChange={(e) => { setProfile({ ...profile, api_secret: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input API secret" />
                                        </div>
                                    </>}


                                {Object.keys(exchangesWithParams).includes(profile.exchange) &&
                                    <div style={{ color: "white", marginTop: 30 }}>
                                        <label>{exchangesWithParams[profile.exchange].label}</label>
                                        <Input value={profile[exchangesWithParams[profile.exchange].param]} onChange={(e) => { setProfile({ ...profile, [exchangesWithParams[profile.exchange].param]: e.target.value }) }} style={{ marginTop: 10 }} placeholder={dex.includes(profile.exchange) ? "Input private key" : "Input Password"} />
                                    </div>
                                }

                                {profile.custom_api_url != null &&
                                    <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Custom API Url (Optional)</label>
                                        <Input value={profile.custom_api_url} onChange={(e) => { setProfile({ ...profile, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                    </div>}
                                {profile.custom_websocket_url != null &&
                                    <div style={{ color: "white", margin: "30px 0" }}>
                                        <label>Custom Websocket Url (Optional)</label>
                                        <Input value={profile.custom_websocket_url} onChange={(e) => { setProfile({ ...profile, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                                    </div>}

                                {!dex.includes(profile.exchange) && <div style={{ color: "white", marginTop: 15 }}>
                                    <Checkbox checked={profile.is_sandbox} style={{ color: "white" }} onChange={(e) => { setProfile({ ...profile, is_sandbox: e.target.checked }) }}>Sandbox mode </Checkbox>
                                </div>}


                                <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0" }}>
                                    {!dex.includes(profile.exchange) &&
                                        <span onClick={() => { handleConnect() }} style={{ textDecoration: "underline" }} >CONNECT</span>
                                    }
                                </div>
                            </div>
                        </div>}

                    </>
                    :
                    <>
                        <div style={{ fontWeight: "600", color: "white" }}>New Exchange API profile</div>
                        <div style={{ color: "grey", marginTop: 10 }}>Connect an exchange account by inputting its API details below. You can get these details visiting your API key page on your exchange account.</div>
                        <div style={{ color: "white", margin: "30px 0" }}>
                            <label>Exchange platform</label>
                            <div>- {exchanges.find(x => x.value === profile.exchange).label || "-"}</div>
                        </div>

                        <div style={{ color: "white", marginBottom: 30, padding: 10 }}>
                            <div style={{ border: "1px solid grey", width: "100%", maxHeight: 400, padding: "0 20px" }}>
                                <h1 style={{ width: 200, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: -10, backgroundColor: "black", color: "white" }}>{exchanges.find(x => x.value === profile.exchange).label} Balance</h1>
                                {/* <div style={{ color: "white", margin: "20px 0" }}>
                                    <label>API key</label>
                                    <div>{profile.api_key || "-"}</div>
                                </div>
                                <div style={{ color: "white" }}>
                                    <label>API secret</label>
                                    <div>{profile.api_secret || "-"}</div>
                                </div> */}
                                <div style={{ overflowY: "auto", height: 300, marginTop: 10 }}>
                                    {profileLoading && <Spin size="large" />}
                                    {profileBalance && Array.isArray(profileBalance) ?
                                        profileBalance.sort((a, b) => b.total - a.total).map(data => <div style={{ display: "flex", flexDirection: "row", gap: 5, marginBottom: 5 }}>
                                            <div>{data.key}:</div>
                                            <div>{data.total}</div>
                                        </div>)
                                        : profileBalance && Object.keys(profileBalance).map(key => <>
                                            <div>{key}:</div>
                                            <div>{JSON.stringify(profileBalance[key])}</div>
                                        </>)}

                                </div>
                            </div>
                        </div>
                    </>
            }


            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button disabled={dex.includes(profile.exchange) ? false : step == 1} onClick={() => {
                    if (!dex.includes(profile.exchange)) {
                        onClickNext()
                    } else {
                        onProfileCreate(profile);
                        setDisplayCreateProfile(false);
                        setStep(0);
                    }
                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NEXT</Button>

            </div>
        </Modal>
    );
};

export default CreateProfileModal;